function gen(name: string, mods: any): string {
  if (!mods) {
    return "";
  }

  if (typeof mods === "string" || typeof mods === "number") {
    return ` ${name}--${mods}`;
  }

  if (Array.isArray(mods)) {
    return mods.reduce((ret, v) => ret + gen(name, v), "");
  }

  return Object.keys(mods).reduce(
    (ret, k) => ret + (mods[k] ? gen(name, k) : ""),
    "",
  );
}

/**
 * bem helper
 * b() // 'button'
 * b('text') // 'button__text'
 * b({ disabled }) // 'button button--disabled'
 * b('text', { disabled }) // 'button__text button__text--disabled'
 * b(['disabled', 'primary']) // 'button button--disabled button--primary'
 */

export function createBEM(name: string) {
  return function (el?: any, ...mods: any) {
    if (!el) return name;

    if (el && typeof el === "string") {
      el = `${name}__${el}`;
    } else {
      mods = el;
      el = name;
    }

    return `${el}${gen(el, mods)}`;
  };
}
